module.exports = __webpack_public_path__ + "static/media/Affordable.e15bb01a.png";